export default __webpack_public_path__ + "static/landing-video-thumbnail-e99dd98f6c6b5f4aceca64359df5db4d.jpg";